export class Pagination {
    totalItems: number;
    currentPage: number;
    itemsPerPage: number;
    maxSize: number;
}


// WEBPACK FOOTER //
// ./src/app/models/pagination.ts